module.exports = __webpack_public_path__ + "static/comment-cropped-b12c1785973ec49a8c0095cc2f57d581.png";